import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function UpdateQuantityMatrixModal({
  updateQuantityMatrixFees,
  updateList,
  id,
  getSingleNewOtherFees,
  getQuantityMatrixCalculationList,
  updating,
}) {
  const [formData, setFormData] = useState({
    unit: '',
    capacity: '',
    amount: '',
  });

  const validateForm = useFormValidator(formData, {
    unit: 'required',
    capacity: 'required',
    amount: 'required',
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const newOtherFeesId = _.get(updateList, 'bpls_other_fee_id');

    const args = {
      ...formData,
      unit: _.get(formData, 'unit'),
      capacity: _.get(formData, 'capacity'),
      amount: _.get(formData, 'amount'),
    };

    updateQuantityMatrixFees(id, newOtherFeesId, args, () => {
      setModal({ isOpen: false });
      getSingleNewOtherFees(newOtherFeesId);
      getQuantityMatrixCalculationList(newOtherFeesId);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Unit: {validateForm.renderMessage('unit')}
            </label>
            <input
              className="form-control"
              type="text"
              name="unit"
              onChange={onChange}
              value={_.get(formData, 'unit')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Capacity: {validateForm.renderMessage('capacity')}
            </label>
            <input
              className="form-control"
              type="text"
              name="capacity"
              onChange={onChange}
              value={_.get(formData, 'capacity')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Amount: {validateForm.renderMessage('amount')}
            </label>
            <input
              className="form-control"
              type="number"
              name="amount"
              onChange={onChange}
              value={_.get(formData, 'amount')}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateQuantityMatrixModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateQuantityMatrixFees: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  getQuantityMatrixCalculationList: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_QUANTITY_MATRIX_FEES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateQuantityMatrixModal);
